






import { Component, Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase';
import MyTable from "../../../components/table/my-table"
import {TenantInfo} from "../../../api/center"
import AddOrEdit from "./parts/addOrEdit.vue"
@Component({components: {MyTable,AddOrEdit}})
export default class CenterManage extends AbpBase{
    addOrEditShow = false
    addOrEditData: any = {}
    data:any [] = []
    columns:any [] = [
        {
            title: '分中心名称',
            key: "name"
        },
        {
            title: '分中心地址',
            key: "address"
        },
        {
            title: '联系人',
            key: "contact"
        },
        {
            title: '联系电话',
            key: "contactNumber"
        },
        {
            title: '透析中心总面积',
            key: "dialysisTotalArea"
        },
        {
            title: '中心等级',
            key: "hisLevel"
        },
        {
            title: '阴性区床位',
            key: "negativeBeds"
        },
        {
            title: '乙肝区床位',
            key: "haspitsBBeds"
        },
        {
            title: '丙肝区床位',
            key: "haspitsBBeds"
        },
        {
            title: '其他隔离区床位',
            key: "otherBeds"
        },
        {
            title: '操作',
            render:(h:any, p:any) => {
                return h('el-button', {
                    props: {type: 'text'},
                    on: {
                        click:() => {
                            this.edit(p)
                        }
                    }
                }, '编辑')
            }
        }
    ]
    created() {
        this.getData()
    }

    private async getData() {
        let res = await TenantInfo({})
        this.data = res.data
    }
    saveSuccess(){
        this.getData()
        this.addOrEditShow = false
    }
    private edit(p: any) {
        this.addOrEditData = {
            data: p.row,
            mode: 'edit'
        }
        this.addOrEditShow = true
    }
}
